export default function IntroStatement() {
    return (
        <div className="intro-box">
            <p className="intro-header"><strong>Welcome to the Buzz Studios Film Archive.</strong></p>
        </div>
    );
}